import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpointsContext } from "@air/provider-media-query";
import { useToasts } from "@air/provider-toast";
import { memo, useEffect, useRef } from "react";
import { AnnotationV2Provider } from "~/components/AnnotationsV2/providers/AnnotationV2Provider";
import { DiscussionsPanelContextProvider } from "~/components/AssetModal/shared/context/DiscussionsPanelContext/DiscussionsPanelContext";
import { PDFOutlineProvider } from "~/components/AssetModalV2/Content/Footer/contexts/PDFOutlineContext";
import { PDFZoomProvider } from "~/components/AssetModalV2/Content/Footer/contexts/PDFZoomContext";
import { ImageSearchContextProvider } from "~/components/AssetModalV2/Content/Header/contexts/ImageSearchContextProvider";
import { PDFSearchBridgeContextProvider } from "~/components/AssetModalV2/Content/Header/contexts/PDFSearchBridgeContextProvider";
import { ImageContentControlsContextProvider } from "~/components/AssetModalV2/Content/ImageContentControlsContextProvider";
import { VideoContentControlsContextProvider } from "~/components/AssetModalV2/Content/VideoContentControlsContextProvider";
import { CollapsibleSectionsContextProvider } from "~/components/AssetModalV2/InfoPanel/CollapsibleSectionsContextProvider";
import { AssetModalPanelContextProvider } from "~/providers/AssetModalPanelContextProvider";
import { ClipTranscriptFetchQueueProvider } from "~/providers/ClipTranscriptFetchQueueProvider";
import { VideoControlProvider } from "~/providers/VideoControlsProvider";
import { VideoTimestampObserverProvider } from "~/providers/VideoTimestampObserverProvider";
import { VideoTimestampProvider } from "~/providers/VideoTimestampProvider";
import { AssetModalPanelsContextProvider } from "../AssetModalV2/AssetModalPanelsContextProvider";
import { AssetModalThemeContextProvider } from "../AssetModalV2/AssetModalThemeContextProvider";
import { FullscreenContextProvider as FullscreenContextProviderV2 } from "../AssetModalV2/shared/context/FullscreenContext";
import { FullscreenContextProvider } from "./shared/context/FullscreenContext";
export const AssetModal = /*#__PURE__*/ memo((param)=>{
    let { desktop, mobile } = param;
    const { isAboveMediumScreen } = useBreakpointsContext();
    const { setToastXOffset, getToastXOffset } = useToasts();
    const previousOffset = useRef(getToastXOffset());
    useEffect(()=>{
        const previousValue = previousOffset.current;
        setToastXOffset(0);
        return ()=>{
            setToastXOffset(previousValue);
        };
    }, [
        setToastXOffset
    ]);
    return /*#__PURE__*/ _jsx("div", {
        "data-theme": "dark",
        children: /*#__PURE__*/ _jsx(AssetModalThemeContextProvider, {
            children: /*#__PURE__*/ _jsx(AssetModalPanelContextProvider, {
                children: /*#__PURE__*/ _jsx(AssetModalPanelsContextProvider, {
                    children: /*#__PURE__*/ _jsx(ImageSearchContextProvider, {
                        children: /*#__PURE__*/ _jsx(PDFSearchBridgeContextProvider, {
                            children: /*#__PURE__*/ _jsx(PDFZoomProvider, {
                                children: /*#__PURE__*/ _jsx(PDFOutlineProvider, {
                                    children: /*#__PURE__*/ _jsx(VideoTimestampProvider, {
                                        children: /*#__PURE__*/ _jsx(VideoTimestampObserverProvider, {
                                            children: /*#__PURE__*/ _jsx(VideoControlProvider, {
                                                children: /*#__PURE__*/ _jsx(VideoContentControlsContextProvider, {
                                                    children: /*#__PURE__*/ _jsx(ImageContentControlsContextProvider, {
                                                        children: /*#__PURE__*/ _jsx(CollapsibleSectionsContextProvider, {
                                                            children: /*#__PURE__*/ _jsx(DiscussionsPanelContextProvider, {
                                                                children: /*#__PURE__*/ _jsx(FullscreenContextProvider, {
                                                                    children: /*#__PURE__*/ _jsx(FullscreenContextProviderV2, {
                                                                        children: /*#__PURE__*/ _jsx(ClipTranscriptFetchQueueProvider, {
                                                                            children: /*#__PURE__*/ _jsx(AnnotationV2Provider, {
                                                                                children: !isAboveMediumScreen ? mobile : desktop
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
});
AssetModal.displayName = "AssetModal";
